import { useState } from 'react';
import {
  IconUp,
  IconDown,
  ButtonPrimary,
  ButtonPseudo,
  ButtonSize,
  IconArrowLeft,
  Checkbox,
  IconRight,
  ClickOutsideDetector,
  notificationCategoriesTree,
} from '@ui/src';
import { CategoryFiltersTypes } from './types';

import cn from './styles.module.css';

const CategoryFilter = ({
  selectedCategories,
  setSelectedCategories,
  selectedGroups,
  setSelectedGroups,
  selectedActions,
  setSelectedActions,
  onApply,
  onClear,
  categories,
  groups,
  types,
  selectedCategory,
  setSelectedCategory,
  selectedGroup,
  setSelectedGroup,
  title,
  withoutCategoryBackButton,
}: CategoryFiltersTypes) => {
  const [categoryFilterVisible, setCategoryFilterVisible] = useState(false);

  let categoryFilterTitle = 'Category';

  if (selectedCategory && !selectedGroup) {
    categoryFilterTitle =
      title ||
      (
        categories?.find((item) => item.value === selectedCategory)
          ?.name as string
      )?.replace('Issues', 'Tasks');
  } else if (selectedGroup && groups) {
    categoryFilterTitle = (
      groups?.find((item) => item.value === selectedGroup)?.name as string
    )?.replace('Issues', 'Tasks');
  }

  let listContent;

  if (!selectedCategory) {
    listContent = categories?.map((item) => {
      const currentCategorySelectedActions: string[] = [];

      const currentCategory = notificationCategoriesTree?.find(
        (category) => category.page === item.value,
      );

      if (currentCategory?.groups) {
        selectedGroups?.forEach((group) => {
          currentCategory?.groups?.forEach((groupItem) => {
            if (
              groupItem.group === group &&
              !currentCategorySelectedActions.find(
                (selectedItem) => selectedItem === group,
              )
            ) {
              currentCategorySelectedActions.push(group);
            }
          });
        });
      }

      return (
        <div key={item.value} className={cn.categoryFilterListItem}>
          <Checkbox
            type="checkbox"
            name={`category-${item.value}`}
            title={item.name?.replace('Issues', 'Tasks')}
            partialChecked={Boolean(
              currentCategorySelectedActions.length &&
              currentCategorySelectedActions.length !==
                currentCategory?.groups?.length,
            )}
            checked={Boolean(
              selectedCategories?.find((category) => category === item.value),
            )}
            value={item.value as string}
            onChange={(e) => {
              const currentGroups = notificationCategoriesTree?.find(
                (category) => category.page === item.value,
              )?.groups;

              let nextSelectedCategories = ([] as string[]).concat(
                selectedCategories as string[],
              );
              let nextSelectedGroups = ([] as string[]).concat(
                selectedGroups as string[],
              );
              let nextSelectedActions = ([] as string[]).concat(
                selectedActions as string[],
              );

              if (
                nextSelectedCategories?.find(
                  (category) => category === item.value,
                )
              ) {
                nextSelectedCategories = nextSelectedCategories?.filter(
                  (category) => category !== item.value,
                );
              } else {
                nextSelectedCategories.push(item.value as string);
              }

              if (currentGroups) {
                if (
                  e.target.checked ||
                  (!selectedCategories?.find(
                    (category) => category === item.value,
                  ) &&
                    Boolean(
                      currentCategorySelectedActions.length &&
                      currentCategorySelectedActions.length !==
                        notificationCategoriesTree[item.value as any]?.groups
                          ?.length,
                    ))
                ) {
                  currentGroups.forEach((groupItem) => {
                    if (
                      !nextSelectedGroups.find(
                        (currentGroupKey) =>
                          currentGroupKey === groupItem.group,
                      )
                    ) {
                      nextSelectedGroups.push(groupItem.group);
                    }

                    groupItem?.types?.forEach((actionItem) => {
                      if (
                        !nextSelectedActions.find(
                          (currentGroupActionKey) =>
                            currentGroupActionKey === actionItem.action,
                        )
                      ) {
                        nextSelectedActions.push(actionItem.action);
                      }
                    });
                  });
                } else {
                  nextSelectedGroups = nextSelectedGroups.filter((groupKey) =>
                    currentGroups.every(
                      (currentGroupItem) => groupKey !== currentGroupItem.group,
                    ),
                  );

                  const currentSelectedGroups =
                    notificationCategoriesTree?.find(
                      (category) => category.page === e.target.value,
                    )?.groups;

                  if (currentSelectedGroups) {
                    const actions: string[] = [];

                    currentSelectedGroups?.forEach((groupItem) => {
                      groupItem?.types?.forEach((actionItem) => {
                        actions.push(actionItem.action);
                      });
                    });

                    nextSelectedActions = nextSelectedActions?.filter(
                      (actionKey) =>
                        actions.every(
                          (action) =>
                            actionKey !== action &&
                            `${actionKey}_ACTION` !== action,
                        ),
                    );
                  }
                }

                setSelectedActions(nextSelectedActions);
                setSelectedGroups(nextSelectedGroups);
              }

              if (setSelectedCategories) {
                setSelectedCategories(nextSelectedCategories);
              }
            }}
          />
          {setSelectedCategory && currentCategory?.groups && (
            <button
              type="button"
              className={cn.openList}
              aria-label="Open next list"
              onClick={() => setSelectedCategory(item.value as string)}
            >
              <IconRight />
            </button>
          )}
        </div>
      );
    });
  } else if (selectedCategory && groups && !selectedGroup) {
    listContent = groups?.map((item) => {
      const currentGroupSelectedActions: string[] = [];

      const currentCategory = notificationCategoriesTree?.find(
        (category) => category.page === selectedCategory,
      );

      const currentGroup = currentCategory?.groups?.find(
        (groupItem) => groupItem.group === item.value,
      );

      if (currentGroup?.types) {
        selectedActions?.forEach((action) => {
          currentGroup?.types?.forEach((actionItem) => {
            if (
              (actionItem.action === action ||
                actionItem.action === `${action}_ACTION`) &&
              !currentGroupSelectedActions.find(
                (selectedItem) =>
                  selectedItem === action ||
                  selectedItem === `${action}_ACTION`,
              )
            ) {
              currentGroupSelectedActions.push(action);
            }
          });
        });
      }

      return (
        <div key={item.value} className={cn.categoryFilterListItem}>
          <Checkbox
            type="checkbox"
            name={`group-${item.value}`}
            title={item.name?.replace('Issues', 'Tasks')}
            checked={Boolean(
              selectedGroups?.find((group) => group === item.value),
            )}
            partialChecked={Boolean(
              currentGroupSelectedActions.length &&
              currentGroupSelectedActions.length !==
                currentGroup?.types?.length,
            )}
            onChange={(e) => {
              const currentGroupActions = currentGroup?.types;

              let nextSelectedGroups = ([] as string[]).concat(
                selectedGroups as string[],
              );
              let nextSelectedActions = ([] as string[]).concat(
                selectedActions as string[],
              );

              const nextSelectedCategories = ([] as string[]).concat(
                selectedCategories as string[],
              );

              if (nextSelectedGroups?.find((group) => group === item.value)) {
                nextSelectedGroups = nextSelectedGroups?.filter(
                  (group) => group !== item.value,
                );
              } else {
                nextSelectedGroups.push(item.value as string);

                if (
                  !nextSelectedCategories.find(
                    (category) => category === selectedCategory,
                  )
                ) {
                  nextSelectedCategories.push(selectedCategory);
                }
              }

              if (currentGroupActions) {
                if (
                  e.target.checked ||
                  (!selectedGroups?.find((group) => group === item.value) &&
                    Boolean(
                      currentGroupSelectedActions.length &&
                      currentGroupSelectedActions.length !==
                        currentGroup.types?.length,
                    ))
                ) {
                  currentGroupActions.forEach((actionItem) => {
                    if (
                      !nextSelectedActions.find(
                        (currentGroupActionKey) =>
                          currentGroupActionKey === actionItem.action,
                      )
                    ) {
                      nextSelectedActions.push(actionItem.action);
                    }
                  });
                } else {
                  nextSelectedActions = nextSelectedActions.filter(
                    (actionKey) =>
                      currentGroupActions.every(
                        (currentGroupActionItem) =>
                          actionKey !== currentGroupActionItem.action &&
                          `${actionKey}_ACTION` !==
                            currentGroupActionItem.action,
                      ),
                  );
                }

                setSelectedActions(nextSelectedActions);
              }

              setSelectedGroups(nextSelectedGroups);

              if (setSelectedCategories) {
                setSelectedCategories(nextSelectedCategories);
              }
            }}
          />
          {currentGroup?.types && (
            <button
              type="button"
              className={cn.openList}
              aria-label="Open next list"
              onClick={() => setSelectedGroup(item.value as string)}
            >
              <IconRight />
            </button>
          )}
        </div>
      );
    });
  } else if (selectedGroup && types) {
    listContent = types?.map((item) => {
      const nameArray = item.name.split(' ');

      return (
        <div key={item.value} className={cn.categoryFilterListItem}>
          <Checkbox
            type="checkbox"
            name={`type-${item.value}`}
            title={
              <div>
                <strong>{nameArray[0]?.replace('Issues', 'Tasks')}</strong> -{' '}
                {nameArray.slice(1).join(' ')}
              </div>
            }
            checked={Boolean(
              selectedActions?.find(
                (action) => action?.replace('_ACTION', '') === item.value,
              ),
            )}
            visualClassName={cn.actionCheckbox}
            onChange={() => {
              const nextSelectedCategories = ([] as string[]).concat(
                selectedCategories as string[],
              );

              const nextSelectedGroups = ([] as string[]).concat(
                selectedGroups as string[],
              );

              let nextSelectedActions = ([] as string[]).concat(
                selectedActions as string[],
              );

              if (
                nextSelectedActions?.find((action) => action === item.value)
              ) {
                nextSelectedActions = nextSelectedActions?.filter(
                  (action) => action !== item.value,
                );
              } else if (
                nextSelectedActions?.find(
                  (action) => action === `${item.value}_ACTION`,
                )
              ) {
                nextSelectedActions = nextSelectedActions?.filter(
                  (action) => action !== `${item.value}_ACTION`,
                );
              } else {
                nextSelectedActions.push(item.value as string);

                if (
                  !selectedCategories?.find(
                    (category) => category === selectedCategory,
                  )
                ) {
                  nextSelectedCategories.push(selectedCategory);
                }

                if (
                  !nextSelectedGroups?.find((group) => group === selectedGroup)
                ) {
                  nextSelectedGroups.push(selectedGroup);
                }
              }

              setSelectedActions(nextSelectedActions);
              setSelectedGroups(nextSelectedGroups);

              if (setSelectedCategories) {
                setSelectedCategories(nextSelectedCategories);
              }
            }}
          />
        </div>
      );
    });
  }

  return (
    <div className={cn.categoryFilterWrapper}>
      <ClickOutsideDetector
        setOptionsListVisible={() => {
          setCategoryFilterVisible(false);

          if (setSelectedCategory) {
            setSelectedCategory('');
          }

          setSelectedGroup('');
        }}
      >
        <>
          <button
            type="button"
            className={`${cn.categoryFilterButton} ${
              categoryFilterVisible ||
              selectedCategories?.length ||
              selectedGroups?.length ||
              selectedActions?.length
                ? cn.active
                : ''
            }`}
            onClick={() => {
              setCategoryFilterVisible(!categoryFilterVisible);
              if (categoryFilterVisible) {
                if (setSelectedCategory) {
                  setSelectedCategory('');
                }
                setSelectedGroup('');
              }
            }}
            disabled={Boolean(selectedCategory && !groups?.length)}
          >
            <div className={cn.buttonText}>{title || 'Category'}</div>
            <div className={cn.iconWrapper}>
              {categoryFilterVisible ? <IconUp /> : <IconDown />}
            </div>
          </button>
          {categoryFilterVisible && (
            <div className={cn.categoryFiltersList}>
              <div className={cn.categoryFilterTitle}>
                {(selectedGroup ||
                  (selectedCategory && !withoutCategoryBackButton)) && (
                  <button
                    type="button"
                    className={cn.backButton}
                    aria-label="Back button"
                    onClick={() => {
                      if (selectedGroup) {
                        setSelectedGroup('');
                      } else if (selectedCategory && setSelectedCategory) {
                        setSelectedCategory('');
                      }
                    }}
                  >
                    <IconArrowLeft />
                  </button>
                )}

                {categoryFilterTitle}
              </div>
              <div className={cn.categoryFilterList}>{listContent}</div>
              <div className={cn.categoryFilterFooter}>
                <ButtonPrimary
                  size={ButtonSize.SMALL}
                  text="Apply"
                  className={cn.applyFilterButton}
                  onClick={() => {
                    onApply();
                    setCategoryFilterVisible(false);
                  }}
                />
                <ButtonPseudo
                  size={ButtonSize.SMALL}
                  text="Clear"
                  onClick={() => {
                    onClear();
                    if (setSelectedCategory) {
                      setSelectedCategory('');
                    }
                    setSelectedGroup('');
                    setCategoryFilterVisible(false);
                  }}
                  className="button-white"
                />
              </div>
            </div>
          )}
        </>
      </ClickOutsideDetector>
    </div>
  );
};

export default CategoryFilter;
